import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button, Grid } from "@mui/material";
import Delivery from "../components/Delivery";

function DeliveryPrint() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <div className="bg-gray-200 p-6">
      <Grid container sx={{ justifyContent: "space-between" }}>
        <Grid item>
          <Button type="button" variant="contained" onClick={handlePrint}>
            {" "}
            Print Delivery{" "}
          </Button>
        </Grid>
      </Grid>

      <Delivery ref={componentRef} />
    </div>
  );
}
export default DeliveryPrint;
